import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBuilding, FaCalendarAlt } from "react-icons/fa";
import { MdDashboard, MdEdit } from "react-icons/md";

const BottomNavigation: React.FC = () => {
  const location = useLocation();

  const navItems = [
    {
      path: "/dashboard",
      icon: MdDashboard,
      label: "ホーム",
    },
    {
      path: "/companies",
      icon: FaBuilding,
      label: "企業",
    },
    {
      path: "/schedules",
      icon: FaCalendarAlt,
      label: "予定",
    },
    {
      path: "/es-templates",
      icon: MdEdit,
      label: "ES",
    },
  ];

  const isActive = (path: string) => {
    if (path === "/companies" && location.pathname.startsWith("/companies")) {
      return true;
    }
    return location.pathname === path;
  };

  return (
    <>
      {/* モバイルのみ表示 */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 shadow-lg">
        <div className="flex justify-around items-center h-16">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex flex-col items-center justify-center flex-1 h-full no-underline transition-colors ${
                  active ? "text-blue-600" : "text-gray-600 hover:text-blue-600"
                }`}
                style={{ minWidth: "44px", minHeight: "44px" }}
              >
                <Icon className="text-2xl mb-1" />
                <span className="text-xs font-medium">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>

      {/* ボトムナビゲーション分のパディングを追加（モバイルのみ） */}
      <div className="md:hidden h-16" />
    </>
  );
};

export default BottomNavigation;
